var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_821_271)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5727 39.1453H36.6752V40C36.6752 40.0762 36.6946 40.0587 36.7289 40H37.4513C37.4827 40.0587 37.5 40.0762 37.5 40H39.5727C39.8087 40 40 39.8087 40 39.5726C40 39.3366 39.8087 39.1453 39.5727 39.1453ZM17.8727 39.1453V20.4312C17.8727 20.1951 17.6815 20.0038 17.4454 20.0038H12.7262C12.4901 20.0038 12.2988 20.1951 12.2988 20.4312V39.1453H8.0441V27.2568C8.0441 27.0208 7.85282 26.8295 7.61675 26.8295H2.89744C2.66137 26.8295 2.47009 27.0208 2.47009 27.2568V39.1453H0.42735C0.191282 39.1453 0 39.3366 0 39.5726C0 39.8087 0.191282 40 0.42735 40H17C17 40.0692 17.0227 40.0549 17.0607 40H17.8384C17.861 40.0549 17.8727 40.0692 17.8727 40V39.1453ZM17.018 20.8585L17.0008 39.1453H13.1535V20.8585H17.018ZM3.32479 27.6842H7.18932V39.1453H3.32479V27.6842Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6752 39.1453V40H17.8727V39.1453H22.1274H27.7013H31.956H36.6752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_821_271",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 12,
    width: 6,
    height: 28,
    rx: 0.6
  })), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 12,
    width: 6,
    height: 28,
    rx: 0.6,
    stroke: "black",
    strokeWidth: 1.6,
    mask: "url(#path-2-inside-1_821_271)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_821_271",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 16,
    width: 6,
    height: 24,
    rx: 0.6
  })), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 16,
    width: 6,
    height: 24,
    rx: 0.6,
    stroke: "black",
    strokeWidth: 1.6,
    mask: "url(#path-3-inside-2_821_271)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.02191 18.9781C2.95071 18.7737 3.05878 18.5503 3.26314 18.4791C12.8833 15.1291 21.3053 10.2039 28.318 3.84279L26.324 3.95092C26.1095 3.96253 25.9232 3.79697 25.9116 3.58083C25.8999 3.36474 26.0655 3.18015 26.2817 3.16837L29.373 3.0006C29.4901 2.99409 29.6042 3.04076 29.6835 3.12753C29.7627 3.21431 29.7989 3.33201 29.782 3.44835L29.336 6.51176C29.3075 6.70666 29.14 6.84713 28.9487 6.84713C28.9298 6.84713 28.9109 6.84582 28.8916 6.84305C28.6776 6.81178 28.5292 6.61292 28.5603 6.3987L28.8485 4.41962C21.7567 10.8536 13.2429 15.8337 3.5208 19.2193C3.4782 19.2341 3.4347 19.2412 3.39194 19.2412C3.22983 19.2413 3.07826 19.1399 3.02191 18.9781Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_821_271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP2);
export default __webpack_public_path__ + "static/media/p2.c221d267749c49ee9c0186d43c17167e.svg";
export { ForwardRef as ReactComponent };